module.exports = "<form class=inp-subtle @submit.prevent.stop=submit @keydown=keydown><span class=inp-subtle-span v-text=term||placeholder></span> <input class=inp-big-focus type=text v-model=term :placeholder=placeholder @blur=blur @input=input><div class=ref-select v-if=options> <div class=ref-option :class=\"{'ref-ghost':$index===ghost}\" v-for=\"opt in options\" v-text=\"opt.item+' '+opt.score\" track-by=item @mouseenter=\"ghost=$index\" @mousedown=confirm(opt.item) transition=staggered></div> </div> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputReference.vue
 ** module id = 135
 ** module chunks = 0
 **/